import { render } from "./ProductReviewItem.vue?vue&type=template&id=5caccf04&scoped=true"
import script from "./ProductReviewItem.vue?vue&type=script&lang=js"
export * from "./ProductReviewItem.vue?vue&type=script&lang=js"

import "./ProductReviewItem.vue?vue&type=style&index=0&id=5caccf04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caccf04"]])

export default __exports__